import PageTabContent from "@/App/Layouts/PageBody/PageTabContent";
import ViewContentBlock from "@/App/Layouts/ViewContentBlock";
import { ViewVariant } from "@/common/ts/layout";
import { AssetSubscriptionDto, EntityType } from "@/core/api/generated/v1";

import GeneralHistoryPaginatedList from "../../../GeneralHistory/ListView/GeneralHistoryPaginatedList";

interface Props {
  assetSubscription: AssetSubscriptionDto;
}

export default function GeneralHistoryTabContent({ assetSubscription }: Props) {
  return (
    <PageTabContent>
      <ViewContentBlock>
        <GeneralHistoryPaginatedList
          defaultValues={{
            subjectEntityType: EntityType.AssetSubscription,
            subjectEntityId: assetSubscription.id,
          }}
          displayProps={{
            viewVariant: ViewVariant.Tab,
          }}
        />
      </ViewContentBlock>
    </PageTabContent>
  );
}
